<template>
<!-- <div> -->
	<!-- <div class="timer" style="position: fixed; top: 140px"> {{timerSec}} </div> -->
	<!-- attention to app! fixied position warning -->
	<transition name="slide-right">
		<div class="banner shadow-box" v-if="active" :style="[$_appViewPosition_margins]">
			<div class="modal-close-x flex-center" @click="close()">
				<i class="fas fa-times" />
			</div>
			<div class="banner-inner">
				<h3>{{ src[caseId].title }}</h3>
				<img :src="randomRecipe.images.small ? randomRecipe.images.small :randomRecipe.images.big">
				<div>
					{{ randomRecipe.title }}
				</div>

			</div>
		</div>
	</transition>
<!-- </div> -->
</template>

<script>

export default {
	data () {
		return {
			active: false,
			randomId: 0,

			caseId: 1,

			src: {
				1: {
					title: 'Non sai da dove cominciare? Questa sta andando a ruba!'
				},
				2: {
					title: 'Ottima scelta! Che ne diresti di aggiungere anche questa?'
				},
				3: {
					title: 'Lo sai che la box più scelta contiene 4 ricette?'
				}
			},

			timing: {
				closeAfter: 10,
				showFirstAfter: 30
			},
			timer: null,
			timerSec: 0
		}
	},

	props: {
		recipesInBox: {
			type: Array,
			default () {
				return null
			}
		},
		menu: {
			type: Object,
			default () {
				return null
			}
		}
	},

	watch: {
		active () {
			if (this.active) {
				this.startTimer()
			}
		},

		timerSec () {
			if (this.active && this.timerSec === this.timing.closeAfter) {
				this.close()
			}
			if (!this.active && this.recipesLength === 0 && this.timerSec === this.timing.showFirstAfter) {
				this.open({ caseId: 1 })
			}
		},

		recipesLength (newV, oldV) {
			this.close()
			this.startTimer()
			if (newV === 0) {
				this.startTimer()
			}

			if (oldV === 0 && newV === 1) {
				this.open({ caseId: 2 })
			}

			if (oldV === 2 && newV === 3) {
				this.open({ caseId: 3 })
			}
		}
	},

	computed: {
		recipesLength () {
			return this.recipesInBox.length
		},

		randomRecipe () {
			return this.menu.recipes.find(r => r.id === this.randomId)
		}
	},

	methods: {
		close () {
			this.active = false
			this.stopTimer()
		},

		open (params) {
			if (!this.menu) return
			this.randomId = this.menuFiltered()[Math.floor(Math.random() * this.menuFiltered().length)].id

		// don't put caseId 0 here. Don't ask, just trust me.
			if (params && params.caseId) {
				this.caseId = params.caseId 
				this.active = true
			}
			
		},

		stopTimer () {
			clearInterval(this.timer)
			this.timerSec = 0
		},

		startTimer () {
			clearInterval(this.timer)
			this.timerSec = 0
			this.timer = setInterval(() => {
				this.timerSec++
			}, 1000)
		},

		menuFiltered () {
			if (!this.menu) return
			return this.menu.recipes.filter(recipe => this.isRecipeToShuffle(recipe))
		},

		isRecipeInBox (recipe) {
			return this.recipesInBox.find(id => id === recipe.id)
		},

		isRecipeToShuffle (recipe) {
			return recipe.available && !this.isRecipeInBox(recipe)
		}

	},

	mounted () {
		if (!this.menu) return

		if (this.recipesLength === 0) {
			this.startTimer()
		}
	}
}

</script>

<style scoped>

.banner {
	position: fixed;
	right: 20px;
	bottom: 100px;
	z-index: 2;
	width: 300px;
	height: auto;
	background-color: var(--quomi-blue);
	border-radius: 4px;
	color: white;
}

img {
	border-radius: 4px;
	margin-bottom: 7px;
}

.banner-inner {
	padding: 20px;
	text-align: left;
	line-height: 1.1;
}

h3 {
	text-align: left;
}

.modal-close-x {
	z-index: 1;
	position: absolute;
	top: 0px;
	right: 0px;
	width: 32px;
	height: 32px;
	text-align: center;
	color: white;
	border-radius: 50%;
	font-size: 18px;
	cursor: pointer;
	line-height: 1;
}

</style>
